/******************************************************************
 * Archivo : client/src/queries/dinamico/fetchDynamicSurveyUserCount.js
 * Proyecto: CB30
 * Módulo  : Visor Dinámico
 *
 * Propósito:
 * Obtener la cantidad de informantes que respondieron al menos
 * una de las encuestas seleccionadas.
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  query DynamicSurveyUserCountQuery($surveyIds: [ID!]!) {
    dynamicSurveyUserCount(surveyIds: $surveyIds)
  }
`;


// WEBPACK FOOTER //
// ./src/queries/dinamico/fetchDynamicSurveyUserCount.js